import { alpha } from "@mui/material";
import tokens from "../tokens/elevation-tokens.json";
import { ElevationTokensEnum } from "../../enums/tokens/elevationTokensEnum";

export const elevationTokens = tokens;

type ElevationLayer = {
  x: number;
  y: number;
  blur: number;
  spread: number;
  color: string;
  opacity: number;
};

/** Composes the CSS box-shadow from the layer specs, top layer first. */
const composeShadow = (layers: ElevationLayer[]): string =>
  layers
    .map(
      (layer) =>
        `${layer.x}px ${layer.y}px ${layer.blur}px ${layer.spread}px ${alpha(
          layer.color,
          layer.opacity
        )}`
    )
    .join(", ");

export const elevations: Record<string, string> = Object.entries(tokens).reduce(
  (acc, [name, token]) => ({ ...acc, [name]: composeShadow(token.layers) }),
  {}
);

export const elevationOptions = Object.keys(elevations);

/** Anything resting flat on the page. */
export const NO_ELEVATION_OPTION = "none";
const NO_ELEVATION_VALUE = "none";

export const elevationControlOptions = [
  NO_ELEVATION_OPTION,
  ...elevationOptions,
];

export const elevationControlMapping: Record<string, string> = {
  [NO_ELEVATION_OPTION]: NO_ELEVATION_VALUE,
  ...elevations,
};

/** Turns an elevation token name into its CSS value, passing raw CSS through untouched. */
export const resolveElevation = (elevation?: string): string =>
  elevationControlMapping[elevation as string] ||
  elevation ||
  NO_ELEVATION_VALUE;

export const DEFAULT_ELEVATION = ElevationTokensEnum.ELEVATION_1;
